const isReactSnap =
  typeof navigator !== "undefined" && navigator.userAgent === "ReactSnap";

export default isReactSnap;

